module.exports = __webpack_public_path__ + "img/doc.b05fe7c0.svg";